import { createContext } from "react";

const TickerIdContext = createContext<string | undefined>(undefined);
TickerIdContext.displayName = "TickerIdContext";

export default TickerIdContext;
